import { CardContent } from "@mui/material";

import commoncss from "../../myfin_v2/css/common.module.css";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import StatusIndicator from '../../myfin_v2/elements/StatusIndicator';
import { ReactComponent as EditIcon } from "../../myfin_v2/assets/icons/editPri.svg";
import  deleteGrey from "../../myfin_v2/assets/icons/deleteGrey.svg";
import sigCss from "../../myfin_v2/css/textEditor.module.css";
import deleteRed from "../../myfin_v2/assets/icons/delete_red.svg";

const Signatory = ({
  signatory,
  editSignatory,
  handleDeleteSignatory
}) => {

return (
  <div
    style={{ width: "100%", height: "140px", backgroundColor: "#F4FAF5", border: "1px solid #C2E6D1", borderRadius: "14px", padding: "30px 60px", display: "flex", justifyContent: "space-between", boxSizing: "border-box", }} >
    <div style={{ display: "flex", flex: 1, alignItems: "stretch" }}>
      <div style={{ marginRight: "30px" }}>
        <div className={`${commoncss.tag} ${commoncss.green_tag}`}>
          {signatory.category === "auditor" ? "Auditor" : "Board of Directors"}
        </div>
      </div>

      {signatory.category === "auditor" && (
        <>
          <div style={{ minWidth: "100px" }}>
            <div className={`${commoncss.label7}`}>For {signatory.firmName}</div>
            <div className={`${commoncss.label6} ${commoncss.fs14} mt-1`}>{signatory.firmRole}</div>
            <div className={`${commoncss.label6} ${commoncss.fs14}`}>{signatory.firmNumber}</div>
          </div>

          <div style={{ width: "1px", backgroundColor: "#C2E6D1", margin: "0 50px", }} />
          <div style={{ minWidth: "160px" }}>
            <div className={`${commoncss.labelBlack} ${commoncss.fw600}`}> {signatory.auditorName}</div>
            <div className={`${commoncss.label6} ${commoncss.fs14} mt-1`}> {signatory.auditorRole}</div>
            <div className={`${commoncss.label6} ${commoncss.fs14}`}>{signatory.membershipNumber}</div>
          </div>
        </>
      )}

      {signatory.category === "board of directors" && (
        <div style={{ minWidth: "160px" }}><div className={`${commoncss.labelBlack} ${commoncss.fw600}`}>{signatory.directorName}</div>
          <div className={`${commoncss.label6} ${commoncss.fs14} mt-1`}>{signatory.directorRole} </div>
          <div className={`${commoncss.label6} ${commoncss.fs14}`}>{signatory.directorNumber}</div>
        </div>
      )}

    </div>
    
    <div style={{ paddingRight: "30px" }}>
      <div style={{ display: "flex", gap: "14px" }}>
        <EditIcon className={commoncss.clickable} onClick={() => editSignatory(signatory._id)}/>
        <img
  src={deleteGrey}
  width="18"
  height="18"
  style={{ cursor: "pointer", transition: "0.15s ease" }}
  onMouseEnter={e => e.currentTarget.src = deleteRed}
  onMouseLeave={e => e.currentTarget.src = deleteGrey}
  onClick={() => handleDeleteSignatory(signatory._id)}
/>

      </div>
    </div>
  </div>
 );

};

export default Signatory;
